import { ProductPreview } from "./ProductPreview.js";

/** @typedef {import("../../data/products.js").Product} Product */

/** @param {Product} product @param {number} index */
export function ProductCard(product, index) {
  return `
    <article class="product-card ${index === 0 ? "product-card-featured" : ""}">
      <div class="product-card-copy">
        <div class="product-number">0${index + 1}</div>
        <span class="product-category">${product.category}</span>
        <h3>${product.name}</h3>
        <p>${product.shortDescription}</p>
        <ul>${product.features.slice(0, 3).map((feature) => `<li>${feature}</li>`).join("")}</ul>
        <a class="text-link" href="${product.route}" data-route>Conocer producto <span aria-hidden="true">→</span></a>
      </div>
      ${ProductPreview({ product })}
    </article>
  `;
}
